import { useState } from "react";
import { useMessageStore } from "../../stores/messageStore.js";
import { useAeThex } from "../../components/AeThexProvider";

export default function ThreadPanel({ messageId }) {
  const [replyText, setReplyText] = useState("");
  const messages = useMessageStore((state) => state.messages);
  const addMessage = useMessageStore((state) => state.addMessage);
  const { user } = useAeThex();

  const parentMessage = messages.find((m) => m.id === messageId);
  const threadReplies = messages.filter((m) => m.threadId === messageId);

  const handleReply = () => {
    if (!replyText.trim() || !parentMessage) return;
    addMessage({
      id: `msg-${Date.now()}`,
      channelId: parentMessage.channelId,
      senderId: user?.id || "user-1",
      senderName: user?.display_name || user?.username || "User",
      text: replyText.trim(),
      timestamp: Date.now(),
      threadId: messageId,
      edited: false,
    });
    setReplyText("");
  };

  if (!parentMessage) return (
    <div style={{ padding: 32, textAlign: "center", color: "rgb(var(--aethex-dim))", fontSize: 13 }}>
      Select a message to view its thread
    </div>
  );

  return (
    <div style={{ background: "rgb(var(--aethex-panel))", border: "1px solid rgb(var(--aethex-border))", borderRadius: 8, padding: 16, maxHeight: 600, overflowY: "auto", minWidth: 320, display: "flex", flexDirection: "column", gap: 12 }}>
      <h3 style={{ color: "rgb(var(--aethex-text))", margin: 0, fontSize: 15, fontWeight: 700 }}>💬 Thread</h3>

      {/* Parent */}
      <div style={{ padding: 12, background: "rgb(var(--aethex-surface))", borderRadius: 8, borderLeft: "3px solid rgb(var(--aethex-primary))" }}>
        <strong style={{ color: "rgb(var(--aethex-primary))", fontSize: 13 }}>{parentMessage.author || parentMessage.senderName}</strong>
        <p style={{ color: "rgb(var(--aethex-muted))", margin: "4px 0 0", fontSize: 13, lineHeight: 1.5 }}>{parentMessage.content || parentMessage.text}</p>
      </div>

      {/* Replies */}
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {threadReplies.length === 0 ? (
          <p style={{ color: "rgb(var(--aethex-dim))", fontSize: 13, margin: 0 }}>No replies yet — be the first!</p>
        ) : (
          threadReplies.map((reply) => (
            <div key={reply.id} style={{ padding: "8px 12px", borderLeft: "2px solid rgb(var(--aethex-border))", background: "rgb(var(--aethex-surface)/0.5)", borderRadius: "0 6px 6px 0" }}>
              <strong style={{ color: "rgb(var(--aethex-muted))", fontSize: 12 }}>{reply.senderName}</strong>
              <p style={{ color: "rgb(var(--aethex-text))", margin: "2px 0 0", fontSize: 13 }}>{reply.text}</p>
            </div>
          ))
        )}
      </div>

      {/* Input */}
      <div style={{ borderTop: "1px solid rgb(var(--aethex-border))", paddingTop: 12 }}>
        <textarea
          value={replyText}
          onChange={(e) => setReplyText(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleReply(); } }}
          placeholder="Reply in thread..."
          rows={2}
          style={{ width: "100%", background: "rgb(var(--aethex-bg))", border: "1px solid rgb(var(--aethex-border))", borderRadius: 6, padding: "8px 10px", color: "rgb(var(--aethex-text))", fontFamily: "'Roboto Mono', monospace", fontSize: 13, marginBottom: 8, boxSizing: "border-box", resize: "none", outline: "none" }}
        />
        <button
          onClick={handleReply}
          disabled={!replyText.trim()}
          style={{ width: "100%", padding: "8px 16px", background: replyText.trim() ? "rgb(var(--aethex-primary)/0.8)" : "rgb(var(--aethex-surface))", border: "1px solid rgb(var(--aethex-border))", borderRadius: 6, color: replyText.trim() ? "#fff" : "rgb(var(--aethex-dim))", cursor: replyText.trim() ? "pointer" : "not-allowed", fontFamily: "'Roboto Mono', monospace", fontWeight: 600, fontSize: 13 }}
        >
          Reply
        </button>
      </div>
    </div>
  );
}
